import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-slider",
  templateUrl: "./med-icon-slider.component.html",
})
export class MedIconSliderComponent extends SvgMixinComponent {}
